"use client";

import { useEffect, useState } from "react";
import { NAV_SECTIONS, NAV_SECTION_EVENT, NAV_SECTION_STORAGE_KEY, pickLocaleText } from "./navStructure";
import { useUiLocale } from "./useUiLocale";

export default function TopMenu() {
  const [activeSection, setActiveSection] = useState<string>("buchen");
  const locale = useUiLocale();

  useEffect(() => {
    try {
      const saved = localStorage.getItem(NAV_SECTION_STORAGE_KEY);
      if (saved && NAV_SECTIONS.some((s) => s.key === saved)) {
        setActiveSection(saved);
      }
    } catch {
      // Ignore storage failures.
    }
  }, []);

  function selectSection(key: string) {
    setActiveSection(key);
    try {
      localStorage.setItem(NAV_SECTION_STORAGE_KEY, key);
    } catch {
      // Ignore storage failures.
    }
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent(NAV_SECTION_EVENT, { detail: { key } }));
    }
  }

  return (
    <nav className="topmenu" aria-label="Hauptnavigation">
      {NAV_SECTIONS.map((s) => (
        <div key={s.key} className="topmenu-item">
          <button
            className={`topmenu-btn ${activeSection === s.key ? "is-open" : ""}`}
            onClick={() => selectSection(s.key)}
            type="button"
          >
            <span aria-hidden="true" style={{ marginRight: 6 }}>{s.icon || "•"}</span>
            {pickLocaleText(locale, s.title, s.titleI18n)}
          </button>
        </div>
      ))}
    </nav>
  );
}
